<template>
  <div class="container">
    <div class="row margin-top">
      <div class="col-10 offset-1">
        <div class="row medium-font">
          <div class="col-3">
            <a href="#">
              <!--<h3><strong><span class="arrow-font">&#x2190;</span> Go back</strong></h3>-->
            </a>
          </div>
          <div class="col-6 text-center">
            <h3><strong>Grow your business with mod24</strong></h3>
          </div>
        </div>
        <div class="row big-font">
          <div class="col text-center">
            <p>
              <strong>
                Thank you for signing up!
                <br />
                We need to verify your phone before proceeding
              </strong>
            </p>
          </div>
        </div>
      </div>
      <div class="col-8 offset-2 background text-center">
        <form @submit.prevent="send" @keydown="clearError($event)" autocomplete="no">
          <div class="form-row">
            <div class="col-md-6 mb-2">
              <input
                v-model="phone"
                :disabled="step !== 'code'"
                @keydown="maskPhone"
                id="phone"
                type="text"
                class="form-control login-input"
                placeholder="Phone number"
              />
            </div>
            <div class="col-md-6">
              <input
                v-model="verification_code"
                :disabled="step !== 'verify'"
                id="code"
                type="text"
                class="form-control login-input"
                placeholder="Verification code"
              />
              <error-field :errors="errors" field="verification_code" />
            </div>
          </div>
          <input type="submit" class="btn btn-primary form-control login-button"
                 :value="step === 'code' ? 'Send code' : 'Verify phone'"
                 :disabled="errors.any()"
          />
        </form>
        <div class="row">
          <div class="col">
            <a v-if="step === 'verify'" href="#" @click="step='code'">Change phone number</a>
          </div>
        </div>
      </div>
      <div class="col-8 offset-2">
        <div class="row">
          <div class="col text-right">
            <a href="#" class="thick-font">Need help?</a><br />
            <p class="info-text">Visit our knowledge base</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState, mapActions } from 'vuex';
import store from 'store';
import Errors from '../../classes/Errors';
import ErrorField from '../ErrorField';
import PhoneMask from '../../classes/PhoneMask';

export default {
  name: 'VerifyPhone',
  components: {
    ErrorField,
  },
  data: () => ({
    step: 'code',
    phone: '',
    verification_code: '',
    phoneMask: new PhoneMask(),
    errors: new Errors(),
  }),
  computed: {
    ...mapState({
      user: state => state.auth.dispatchUser,
    }),
  },
  mounted() {
    this.getAuthFromStorage();
  },
  methods: {
    ...mapActions(['getAuthFromStorage']),
    send() {
      if (this.step === 'code') {
        this.sendCode();
      } else {
        this.verifyPhone();
      }
    },
    maskPhone() {
      this.$nextTick(() => {
        this.$set(this, 'phone', this.phoneMask.maskedPhone(this.phone));
      });
    },
    sendCode() {
      axios
        .post('resend-phone', { phone: this.phone })
        .then(() => {
          this.step = 'verify';
        })
        .catch(err => {
          this.step = 'code';
          this.errors.record(err.response.data.error);
        });
    },
    verifyPhone() {
      axios
        .post('verify-phone', { verification_code: this.verification_code })
        .then(() => {
          const user = store.get('dispatchUser');
          user.phone_verified = 1;
          store.set('dispatchUser', user);
          this.getAuthFromStorage();
          this.$router.push('/');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/auth/VerifyPhone.vue